import { formatMoney } from "../../../utils/formatUtils";

export function buildAccountSearchText(account) {
  return [
    account?.bank || "",
    account?.accountNumber || "",
    account?.currency || "",
    account?.institutionName || "",
  ]
    .join(" ")
    .toLowerCase();
}

export function flattenExternalInstitutionAccounts(externalInstitutions) {
  return (externalInstitutions || []).flatMap((item) =>
    (item.currencies || []).flatMap((currencyGroup) =>
      (currencyGroup.accounts || []).map((account) => ({
        ...account,
        institutionId: item.institution?.id ?? null,
        institutionName: item.institution?.name || "-",
        institutionType: item.institution?.type || "-",
        currencyCode: currencyGroup.currencyCode,
      }))
    )
  );
}

export function renderAccountOptionLabel(account, transferScope) {
  return (
    <div className="flex flex-col py-1">
      <div className="font-medium text-slate-800">
        {account.bank || "-"} - {account.accountNumber || "-"} ({account.currency || "-"})
      </div>

      {transferScope === "EXTERNAL" && (
        <div className="mt-1 text-xs text-slate-500">
          Байгууллага: <span className="font-medium text-slate-700">{account.institutionName || "-"}</span>
        </div>
      )}

      <div className="mt-1 flex flex-wrap gap-x-4 text-xs text-slate-500">
        <span>
          Үлдэгдэл:{" "}
          <span className="font-medium text-slate-700">
            {formatMoney(account.balance, account.currency)}
          </span>
        </span>

        <span>
          Wallet:{" "}
          <span className="font-medium text-slate-700">
            {formatMoney(account.walletBalance, account.currency)}
          </span>
        </span>
      </div>
    </div>
  );
}